import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SplashScreen from "./components/SplashScreen";

import Landing from "./pages/landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CompanyDashboard from "./pages/CompanyDashboard";
import CompanyLayout from "./pages/company/CompanyLayout";
import AdminPanel from "./pages/AdminPanel";
import ProtectedRoute from "./components/ProtectedRoute";
import CompanyProfile from "./pages/admin/CompanyProfile";
import EventManager from "./pages/admin/EventManager";
import EventForm from "./pages/admin/EventForm";
import CompanyProfileLanding from "./pages/CompanyProfile";
import EditProduct from "./pages/company/EditProduct";
import CompanyUsers from "./pages/company/CompanyUsers";
import CompanyPosts from "./pages/company/CompanyPosts";
import CompanySeccions from "./pages/company/CompanySeccions";
import CompanySedes from "./pages/company/CompanySedes";
import CompanyReviews from "./pages/company/CompanyReviews";
import CompanyRyders from "./pages/company/CompanyRyders";
import CompanyOrders from "./pages/company/CompanyOrders";
import CompanyCoupons from "./pages/company/CompanyCoupons";
import CompanyMetrics from "./pages/company/CompanyMetrics";
import CompanyDispatch from "./pages/company/CompanyDispatch";
import CompanyTables from "./pages/company/CompanyTables";
import CompanyDailyCash from "./pages/company/CompanyDailyCash";
import CompanyPrinters from "./pages/company/CompanyPrinters";
import DeliveryLayout from "./pages/delivery/DeliveryLayout";
import DeliveryDashboard from "./pages/delivery/DeliveryDashboard";
import DeliveryApplications from "./pages/delivery/DeliveryApplications";
import DeliveryRyders from "./pages/delivery/DeliveryRyders";
import DeliveryDispatch from "./pages/delivery/DeliveryDispatch";
import DeliveryProfile from "./pages/delivery/DeliveryProfile";
import RegisterDelivery from "./pages/delivery/RegisterDelivery";
import AdminRyders from "./pages/admin/AdminRyders";
import SedeProfile from "./pages/SedeProfile";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Favorites from "./pages/Favorites";
import ClientDashboard from "./pages/ClientDashboard";
import WheelOfFortune from "./pages/WheelOfFortune";
import MyPrizes from "./pages/MyPrizes";
import MyProfile from "./pages/user/MyProfile";
import MyOrders from "./pages/user/MyOrders";
import EventPage from "./pages/EventPage";
import EventCeremony from "./pages/EventCeremony";
import EventProducts from "./pages/EventProducts";
import RegisterBusiness from "./pages/RegisterBusiness";
import AddCompanyForm   from "./pages/AddCompanyForm";
import RegisterRyder from "./pages/RegisterRyder";
import RegisterBurgerFest from "./pages/RegisterBurgerFest";
import RyderDashboard from "./pages/RyderDashboard";
import Navbar from "./components/Navbar";
import { ToastContainer } from "react-toastify";
import OrderDetail from "./pages/company/orders/OrderDetail";
import ConvertToRyder from "./pages/ConvertToRyder";
import MapaPage from "./pages/MapaPage";
import InstalacionPWA from "./components/InstalacionPWA";
import PermissionPrompt from "./components/PermissionPrompt";
import CompanyOrderNotifier from "./components/CompanyOrderNotifier";
import RyderOrderNotifier from "./components/RyderOrderNotifier";
import PushRegistrar from "./components/PushRegistrar";
import TransportNotifier from "./components/TransportNotifier";
import TransportPage from "./pages/TransportPage";
import TransportRyderPage from "./pages/TransportRyderPage";
import TransportAdmin from "./pages/admin/TransportAdmin";
import EmployeeComanda from "./pages/EmployeeComanda";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import AddWhatsapp from "./pages/AddWhatsapp";
import NotificationsInbox from "./pages/Notifications";
import OffersPage from "./pages/OffersPage";
import AuctionList from "./pages/AuctionList";
import AuctionDetail from "./pages/AuctionDetail";
import CompanyAuctions from "./pages/company/CompanyAuctions";
import CompaniesPage from "./pages/CompaniesPage";
import { SearchProvider } from "./context/SearchContext";
import LandingPopup from "./components/LandingPopup";
import AnonymousPresence from "./components/AnonymousPresence";
import StatusBarScrim from "./components/StatusBarScrim";

export default function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <>
      {!splashDone && <SplashScreen onDone={() => setSplashDone(true)} />}
      <BrowserRouter>
      <SearchProvider>
        <StatusBarScrim />
        <LandingPopup />
        <AnonymousPresence />
        <InstalacionPWA />
        <PermissionPrompt />
        <PushRegistrar />
        <CompanyOrderNotifier />
        <RyderOrderNotifier />
        <TransportNotifier />
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/companies" element={<CompaniesPage />} />
          <Route path="/ofertas" element={<OffersPage />} />
          <Route path="/auctions" element={<AuctionList />} />
          <Route path="/auction/:id" element={<AuctionDetail />} />
          <Route path="/sede/:id" element={<SedeProfile />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/map" element={<MapaPage />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/event/:id" element={<EventPage />} />
          <Route path="/event/:id/ceremony" element={<EventCeremony />} />
          <Route path="/event/:id/productos" element={<EventProducts />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/agregar-whatsapp/:token" element={<AddWhatsapp />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute roles={["user", "company", "admin", "ryder", "delivery"]}>
                <NotificationsInbox />
              </ProtectedRoute>
            }
          />
          <Route
            path="/myprofile"
            element={
              <ProtectedRoute roles={["user", "company", "admin", "ryder", "delivery"]}>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          {/* ── Company panel (con sidebar layout) ─────────── */}
          <Route element={<ProtectedRoute roles={["company"]}><CompanyLayout /></ProtectedRoute>}>
            <Route path="/company"             element={<CompanyDashboard />} />
            <Route path="/company/posts"       element={<CompanyPosts />} />
            <Route path="/company/sedes"       element={<CompanySedes />} />
            <Route path="/company/seccions"    element={<CompanySeccions />} />
            <Route path="/company/users"       element={<CompanyUsers />} />
            <Route path="/company/reviews"     element={<CompanyReviews />} />
            <Route path="/company/ryders"      element={<CompanyRyders />} />
            <Route path="/company/coupons"     element={<CompanyCoupons />} />
            <Route path="/company/auctions"    element={<CompanyAuctions />} />
            <Route path="/company/metrics"     element={<CompanyMetrics />} />
            <Route path="/company/dispatch"    element={<CompanyDispatch />} />
            <Route path="/company/mesas"       element={<CompanyTables />} />
            <Route path="/company/caja"        element={<CompanyDailyCash />} />
            <Route path="/company/impresoras"  element={<CompanyPrinters />} />
            <Route path="/company/orders"      element={<CompanyOrders />} />
            <Route path="/company/:id/orders"  element={<CompanyOrders />} />
            <Route path="/order/:id"           element={<OrderDetail />} />
            <Route path="/edit-product/:id"    element={<EditProduct />} />
          </Route>

          {/* ── Delivery company panel ────────────────────────── */}
          <Route element={<ProtectedRoute roles={["delivery"]}><DeliveryLayout /></ProtectedRoute>}>
            <Route path="/delivery"                  element={<Navigate to="/delivery/dispatch" replace />} />
            <Route path="/delivery/dashboard"        element={<DeliveryDashboard />} />
            <Route path="/delivery/applications"     element={<DeliveryApplications />} />
            <Route path="/delivery/ryders"           element={<DeliveryRyders />} />
            <Route path="/delivery/dispatch"         element={<DeliveryDispatch />} />
            <Route path="/delivery/profile"          element={<DeliveryProfile />} />
          </Route>

          <Route path="/register-delivery" element={<RegisterDelivery />} />

          {/* Perfil público de empresa (sin layout de panel) */}
          <Route path="/company/:id" element={<CompanyProfileLanding />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin/companies/:id" element={<CompanyProfile />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={["admin"]}>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/events"
            element={
              <ProtectedRoute roles={["admin"]}>
                <EventManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/events/new"
            element={
              <ProtectedRoute roles={["admin"]}>
                <EventForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/events/:id/edit"
            element={
              <ProtectedRoute roles={["admin"]}>
                <EventForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/myaccount"
            element={
              <ProtectedRoute roles={["user", "ryder", "admin", "company", "delivery"]}>
                <ClientDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/register-business" element={<RegisterBusiness />} />
          <Route
            path="/add-company"
            element={
              <ProtectedRoute roles={["user", "admin"]}>
                <AddCompanyForm />
              </ProtectedRoute>
            }
          />
          <Route path="/checkout" element={<Checkout />} />
          <Route
            path="/ruleta"
            element={
              <ProtectedRoute roles={["user", "ryder", "admin", "company", "delivery"]}>
                <WheelOfFortune />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ruleta/premios"
            element={
              <ProtectedRoute roles={["user", "ryder", "admin", "company", "delivery"]}>
                <MyPrizes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-orders"
            element={
              <ProtectedRoute roles={["user", "company", "admin", "ryder", "delivery"]}>
                <MyOrders />
              </ProtectedRoute>
            }
          />
          <Route path="/register-ryder" element={<RegisterRyder />} />
          <Route path="/register-burgerfest" element={<RegisterBurgerFest />} />
          <Route path="/ryder-dashboard" element={<RyderDashboard />} />
          <Route
            path="/admin/ryders"
            element={
              <ProtectedRoute roles={["admin"]}>
                <AdminRyders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ryder"
            element={
              <ProtectedRoute roles={["user", "ryder", "admin"]}>
                <RyderDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/convert-to-ryder"
            element={
              <ProtectedRoute roles={["user"]}>
                <ConvertToRyder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transport"
            element={
              <ProtectedRoute roles={["user", "company", "admin", "ryder"]}>
                <TransportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transport/conductor"
            element={
              <ProtectedRoute roles={["ryder"]}>
                <TransportRyderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/transport"
            element={
              <ProtectedRoute roles={["admin"]}>
                <TransportAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comanda"
            element={
              <ProtectedRoute roles={["user", "company"]}>
                <EmployeeComanda />
              </ProtectedRoute>
            }
          />
        </Routes>
        <ToastContainer position="top-center" autoClose={3000} />
      </SearchProvider>
      </BrowserRouter>
    </>
  );
}
